import { addMessages } from '@hana/i18n';

// Khoá chuỗi của ngăn Thêm / Sửa nguồn feed (FeedSourceDrawer.tsx). Nhãn trường và loại nguồn lấy từ news.ts (chưa dịch).
addMessages('vi', {
  'fd.noWrite': 'Chưa bật ghi nguồn feed',
  'fd.noUrl': 'Thiếu URL · không thử được',
  'fd.noTest': 'Chưa bật chạy thử nguồn ở bản này',
  'fd.add': 'Thêm nguồn feed',
  'fd.edit': 'Sửa nguồn · {name}',
  'fd.newSub': 'Nguồn mới · Đọc nguồn theo lịch',
  'fd.del': 'Xoá nguồn',
  'fd.create': 'Tạo nguồn',
  'fd.save': 'Lưu nguồn',
  'fd.fill': 'Điền các trường có dấu *',
  'fd.kind': 'Loại',
  'fd.kindAria': 'Loại nguồn',
  'fd.on': 'Bật nguồn',
  'fd.testTitle': 'Thử nguồn',
  'fd.run': 'Chạy thử',
  'fd.noProbe': 'Chưa bật Hana dò trang tin',
  'fd.probe': 'Hana dò trang tin',
  'fd.idle': 'Chưa thử · bấm Chạy thử để xem nguồn trả gì',
});
addMessages('en', {
  'fd.noWrite': 'Writing feed sources is not enabled',
  'fd.noUrl': 'Missing URL · cannot test',
  'fd.noTest': 'Source test is not enabled in this version',
  'fd.add': 'Add feed source',
  'fd.edit': 'Edit source · {name}',
  'fd.newSub': 'New source · Read on schedule',
  'fd.del': 'Delete source',
  'fd.create': 'Create source',
  'fd.save': 'Save source',
  'fd.fill': 'Fill in the fields marked *',
  'fd.kind': 'Type',
  'fd.kindAria': 'Source type',
  'fd.on': 'Enable source',
  'fd.testTitle': 'Test source',
  'fd.run': 'Run test',
  'fd.noProbe': 'Hana news-page probe is not enabled',
  'fd.probe': 'Hana probes news page',
  'fd.idle': 'Not tested · press Run test to see what the source returns',
});
